import { NgModule, Optional, SkipSelf } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

class EnsureModuleLoadedOnceGuard {
  constructor(targetModule: any) {
    if (targetModule) {
      throw new Error(
        `${targetModule.constructor.name} has already been loaded. Import this module in the AppModule only.`
      );
    }
  }
}

import {
  AdminService,
  ApiService,
  AuthGuard,
  SuperAdminAuthGuard,
  ClipboardService,
  JwtService,
  ProfileService,
  TenantService,
  CloudNamesService,
  TokenInterceptor,
  AdminsApiService,
} from './index';

@NgModule({
  providers: [
    AdminService,
    ApiService,
    AuthGuard,
    SuperAdminAuthGuard,
    ClipboardService,
    JwtService,
    ProfileService,
    TenantService,
    CloudNamesService,
    AdminsApiService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
})
export class ApiModule extends EnsureModuleLoadedOnceGuard {
  constructor(@Optional() @SkipSelf() parentModule: ApiModule) {
    super(parentModule);
  }
}
